import * as yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';
const local_language = localStorage.getItem('lang')

const LoginValidation: any = yup.object().shape({
    // email: yup.string().required(ValidationMessage.Field("email"))
    //     .email(ValidationMessage.EMAIL_ADDRESS)
    //     .matches(ValidationMessage.EMAIL_REGREX, ValidationMessage.EMAIL_ADDRESS)
    //     .trim(),

    email: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("email") : ValidationMessage.Field("email"))
        .email(local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS : ValidationMessage.EMAIL_ADDRESS)
        .matches(ValidationMessage.EMAIL_REGREX, local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS : ValidationMessage.EMAIL_ADDRESS)
        .trim(),


    password: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("fjalëkalimin") : ValidationMessage.Field("password"))
        // .min(8, ValidationMessage?.MinLength('Password', 8))
        // .max(15, ValidationMessage?.MaxLength('Password', 15))
        .matches(/^\S*$/, local_language == "alb" ? ValidationMessageAlbanian.Field("fjalëkalimin") : ValidationMessage?.NO_SPACE_ALLOWED),

});

export default LoginValidation;

